<template>
  <generic-modal
    size="large"
    :title="$t('staff rating template configuration')"
    icon="cogs"
    image="/images/icons/staff_rating.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
  >
    <div class="description">
      <generic-container
        v-bind:show_plus="true"
        icon="cubes"
        :title="$t('categories')"
        v-on:add="add_setting"
        :header_buttons="header_buttons"
      >
        <liquor-tree
          :data="tree.data"
          ref="tree"
          @node:clicked="node_selected"
        />
      </generic-container>
    </div>
    <category-modal ref="category_modal" @success="success_category" />
  </generic-modal>
</template>

<script>
import LiquorTree from "liquor-tree";
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast, warning_toast } from "@/utils";
// import { v4 } from "uuid";
import CategoryModal from "@/modules/staff_rating/template/category_modal/Index";

export default {
  name: "StaffRatingTemplateConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    GenericContainer,
    LiquorTree,
    CategoryModal,
  },
  computed: {},
  data() {
    return {
      setup: {},
      tree: {
        data: [],
        selected_node: undefined,
      },
      header_buttons: [
        {
          icon: "blue asterisk",
          click: this.add_root,
          tooltip: this.$t("add root"),
        },
        {
          icon: "orange edit",
          click: this.edit,
          tooltip: this.$t("edit"),
        },
        {
          icon: "red trash",
          click: this.remove,
          tooltip: this.$t("delete"),
        },
      ],
      categories: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      // let vm = this;
      return new Promise(function(resolve /* reject */) {
        // local_api(vm, "post", "/staff_rating/template/do-save-configuration", {
        //   s: vm.setup,
        // })
        //   .then(() => {
        resolve();
        // })
        // .catch((err) => {
        //   reject(err);
        // });
      });
    },
    add_root() {
      let vm = this;
      vm.$refs.category_modal.show_modal();
    },
    edit() {
      let vm = this;
      // let treeRef = vm.$refs.tree;
      let node = vm.tree.selected_node;
      // console.log("node", node);
      if (node) {
        let vm = this;
        vm.$refs.category_modal.show_modal({
          id: node.id,
          text: node.data.text,
          parent: node.parent ? node.parent.id : null,
        });
      } else {
        warning_toast(vm.$t("select a category in order to edit"));
      }
    },
    add_setting() {
      let vm = this;

      let node = vm.tree.selected_node;
      // console.log("node", node);
      if (node) {
        let vm = this;
        vm.$refs.category_modal.show_modal({ parent: node.id });
      } else {
        warning_toast(
          vm.$t("select a category in order to create a sub-category"),
        );
      }
    },
    remove() {
      let vm = this;
      let node = vm.tree.selected_node;
      // console.log("node", node);
      if (node) {
        vm.$alertify.confirm(
          vm.$t("are you sure to delete category?"),
          function() {
            local_api(vm, "post", "/staff_rating/template/do-remove-category", {
              u: node.id,
            })
              .then((r) => {
                console.log(r);
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
      } else {
        warning_toast(vm.$t("select a category in order to delete it"));
      }
    },
    node_selected(node) {
      this.tree.selected_node = node;
      // console.log("node", node);
    },
    success_category(data) {
      // this.init();
      let vm = this;
      let treeRef = vm.$refs.tree;
      // console.log(data, vm.tree.selected_node);
      if (data) {
        if (data.parent && vm.tree.selected_node) {
          vm.tree.selected_node.append({ id: data.id, text: data.name });
        } else {
          treeRef.append({ id: data.id, text: data.name });
        }
      }
    },
    searchCategories(parent_node) {
      return new Promise((resolve, reject) => {
        try {
          let vm = this;
          let subcats = vm.categories.filter(
            (c) => c.parent_category_id == parent_node.category_id,
          );

          let prmss = subcats.map((c) => {
            return vm.searchCategories(c);
          });

          Promise.all(prmss)
            .then((vls) => {
              resolve({
                id: parent_node.uuid,
                text: parent_node.name,
                children: vls,
              });
            })
            .catch((err) => {
              console.error(err);
              reject(err);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    init() {
      let vm = this;
      let treeRef = vm.$refs.tree;
      // console.log(treeRef);
      local_api(vm, "post", "/staff_rating/template/do-get-categories")
        .then((conf) => {
          if (conf) {
            vm.categories = conf;
            vm.searchCategories({})
              .then((root) => {
                let roots = root.children;
                roots.map((r) => {
                  treeRef.append(r);
                });
              })
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
  updated: function() {},
};
</script>
